(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["australia-b2b-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const publish = (name, data = {}) => {
      const payload = {page_type: 'australia_b2b_landing', ...data};
      document.documentElement.dataset.rsB2bLastEvent = name;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: name, ...payload});
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        try {
          const result = Shopify.analytics.publish(`rockshelfit:${name}`, payload);
          if (result && typeof result.catch === 'function') result.catch(() => {});
        } catch (error) {
          return;
        }
      }
    };

    const syncAttribution = (root) => {
      const params = new URLSearchParams(window.location.search);
      root.querySelectorAll('[data-utm-field]').forEach((field) => {
        const value = params.get(field.dataset.utmField) || '';
        field.value = value;
        field.defaultValue = value;
        field.setAttribute('value', value);
      });
    };

    const initialise = () => document.querySelectorAll('[data-rs-b2b]').forEach((root) => {
      if (root.dataset.trackingReady === 'true') return;
      root.dataset.trackingReady = 'true';
      const form = root.querySelector('#RockShelfItB2BLeadForm');
      syncAttribution(root);
      root.dataset.utmReady = 'true';

      publish('b2b_landing_viewed');
      root.dataset.viewEventReady = 'true';

      if (form) {
        let started = false;
        form.addEventListener('focusin', () => {
          syncAttribution(root);
          if (started) return;
          started = true;
          publish('b2b_form_started');
        });
        form.addEventListener('submit', () => {
          syncAttribution(root);
          publish('b2b_form_submitted');
        });
      }

      root.querySelectorAll('[data-b2b-cta]').forEach((button) => {
        button.addEventListener('click', () => publish('b2b_quote_cta_clicked'));
      });

      const success = root.querySelector('[data-lead-success]');
      if (success) {
        const key = `rs-b2b-lead-${window.location.pathname}-${window.location.search}`;
        if (!window.sessionStorage.getItem(key)) {
          publish('b2b_lead_submitted', {lead_type: 'commercial_shelving_quote'});
          window.sessionStorage.setItem(key, '1');
        }
        success.focus();
      }
    });

    const start = () => window.setTimeout(initialise, 250);
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, {once: true});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rockshelfit-b2b-contact"] && !Shopify.designMode) return;
  try {
    
function rsPrefillQuote() {
  const form = document.getElementById('RockShelfItB2BQuote');
  if (!form || form.dataset.prefilled) return;
  if (!document.getElementById('rsq-request-type')) return;
  form.dataset.prefilled = 'true';
  const params = new URLSearchParams(window.location.search);
  const requestType = document.getElementById('rsq-request-type');
  const destination = document.getElementById('rsq-destination');
  const details = document.getElementById('rsq-shipping-details');
  const copyElements = ['rsq-heading','rsq-intro','rsq-submit'].map(id => document.getElementById(id));
  for (const element of copyElements) element.dataset.general = element.textContent;
  function syncRequest() {
    const fedex = requestType.value === 'FedEx shipping quote from China';
    destination.required = !fedex;
    destination.hidden = fedex;
    document.getElementById('rsq-destination-label').hidden = fedex;
    for (const name of ['country','city','postcode']) {
      const field = document.getElementById('rsq-' + name);
      field.required = fedex;
      field.addEventListener('invalid', () => { details.open = true; }, {once:true});
    }
    if (fedex) details.open = true;
    for (const element of copyElements) element.textContent = fedex ? element.dataset.fedex : requestType.value === 'Store layout and shelving quote' ? element.dataset.layout : element.dataset.general;
  }
  if (params.get('request') === 'layout' || /layout/i.test(params.get('product') || '')) requestType.value = 'Store layout and shelving quote';
  if (params.get('request') === 'fedex') requestType.value = 'FedEx shipping quote from China';
  requestType.addEventListener('change', syncRequest);
  syncRequest();
  const market = document.getElementById('rsq-market');
  const marketNote = document.getElementById('rsq-market-note');
  const country = document.getElementById('rsq-country');
  const marketParam = (params.get('market') || '').toLowerCase();
  if (['us','usa','united states'].includes(marketParam)) market.value = 'United States';
  if (['au','australia'].includes(marketParam)) market.value = 'Australia';
  function updateMarket() {
    const key = market.value === 'United States' ? 'us' : market.value === 'Australia' ? 'au' : '';
    marketNote.hidden = !key;
    marketNote.textContent = key ? marketNote.dataset[key] : '';
    if (key) { country.value = market.value; country.dataset.marketSet = 'true'; }
    else if (country.dataset.marketSet) { country.value = ''; delete country.dataset.marketSet; }
  }
  market.addEventListener('change',updateMarket);
  updateMarket();
  const safeStore = { get(key) { try { return sessionStorage.getItem(key); } catch { return null; } }, set(key,value) { try { sessionStorage.setItem(key,value); } catch {} } };
  let reference = safeStore.get('rs-pending-enquiry');
  if (!reference) {
    reference = 'RS-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2,8).toUpperCase();
    safeStore.set('rs-pending-enquiry',reference);
  }
  document.getElementById('rsq-reference').value = reference;
  document.getElementById('rsq-landing').value = location.pathname;
  for (const key of ['source','medium','campaign']) document.getElementById('rsq-utm-' + key).value = (params.get('utm_' + key) || '').slice(0,240);
  let saved;
  try { saved = JSON.parse(safeStore.get('rs-enquiry-draft') || 'null'); } catch {}
  if (saved && saved.path === location.pathname && Date.now() - saved.time < 3600000) {
    for (const [name,value] of Object.entries(saved.fields)) {
      const input = form.elements.namedItem(name);
      if (input && !['hidden','submit'].includes(input.type) && !input.value) input.value = value;
    }
  }
  const mapping = {product:'requirement',quantity:'estimated',destination:'destination',configuration:'configuration',sku:'sku',source:'source'};
  for (const [param, field] of Object.entries(mapping)) {
    const input = document.getElementById('rsq-' + field);
    if (input && !input.value && params.has(param)) input.value = params.get(param).slice(0,240);
  }
  updateMarket();
  syncRequest();
  const context = document.getElementById('rsq-context');
  const configuration = params.get('configuration');
  if (context && configuration && configuration !== 'Default Title') { context.textContent = configuration.slice(0,240); context.hidden = false; }
  if (params.get('cart') === '1') {
    const items = document.getElementById('rsq-cart-data');
    if (items) {
      const summary = JSON.parse(items.textContent);
      document.getElementById('rsq-cart').value = summary;
      document.getElementById('rsq-notes').value = summary;
    }
  }
  form.addEventListener('submit', () => {
    const fields = {};
    for (const input of form.elements) if (input.name && input.name.startsWith('contact[') && !['hidden','submit'].includes(input.type)) fields[input.name] = input.value;
    safeStore.set('rs-enquiry-draft', JSON.stringify({path:location.pathname,time:Date.now(),fields}));
    const notes = document.getElementById('rsq-notes');
    if (requestType.value === 'FedEx shipping quote from China') {
      destination.value = ['country','city','postcode','region','street'].map(name => document.getElementById('rsq-' + name).value.trim()).filter(Boolean).join(', ');
      form.querySelector('input[name="contact[subject]"]').value = 'RockShelfIt total order and freight quote';
      const detailsText = 'Order quote — confirm availability, dispatch origin and freight before full payment\n' + document.getElementById('rsq-requirement').value + '\nQuantity: ' + document.getElementById('rsq-estimated').value + '\nDestination: ' + destination.value;
      notes.value = detailsText + (notes.value.trim() ? '\n\n' + notes.value : '');
    }
    if (!notes.value.trim()) notes.value = document.getElementById('rsq-requirement').value + '\n' + document.getElementById('rsq-estimated').value + '\n' + document.getElementById('rsq-destination').value;
  });
}
function rsConfirmedEnquiry() {
  const success = document.querySelector('[data-rs-confirmed-success]');
  if (!success || success.dataset.handled) return;
  success.dataset.handled = 'true';
  try {
    const reference = sessionStorage.getItem('rs-pending-enquiry');
    if (!reference) return;
    sessionStorage.setItem('rs-confirmed-enquiry',JSON.stringify({reference,time:Date.now()}));
    sessionStorage.removeItem('rs-pending-enquiry');
    sessionStorage.removeItem('rs-enquiry-draft');
    const url = new URL('/pages/quote-received',location.origin);
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id',preview);
    location.replace(url.href);
  } catch {}
}
rsPrefillQuote();
rsConfirmedEnquiry();
document.addEventListener('shopify:section:load',() => { rsPrefillQuote(); rsConfirmedEnquiry(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-enquiry-thanks"] && !Shopify.designMode) return;
  try {
    
function rsThankYou(){
 const root=document.querySelector('.rs-thanks');if(!root)return;
 let confirmation;try{confirmation=JSON.parse(sessionStorage.getItem('rs-confirmed-enquiry')||'null');}catch{}
 if(!confirmation||!/^RS-[A-Z0-9]+-[A-Z0-9]+$/.test(confirmation.reference)||Date.now()-confirmation.time>86400000)return;
 root.querySelector('h1').textContent=root.querySelector('h1').dataset.confirmed;
 root.querySelector('[data-enquiry-reference]').textContent=confirmation.reference;
 root.querySelector('.rs-thanks-reference').hidden=false;root.querySelector('[data-enquiry-direct]').hidden=true;
 root.querySelector('[data-enquiry-wa]').href='https://wa.me/8615010997212?text='+encodeURIComponent('Hi RockShelfIt, my enquiry reference is '+confirmation.reference+'. I would like to add my floor plan or project photos.');
 root.querySelector('[data-enquiry-email]').href='mailto:service@rockshelfit.com?subject='+encodeURIComponent('Project details — '+confirmation.reference);
}
rsThankYou();document.addEventListener('shopify:section:load',rsThankYou);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-market-layout"] && !Shopify.designMode) return;
  try {
    
function rsPlaceMarketOptions(){const market=document.querySelector('.rs-market');const hero=document.querySelector('.rs-layout .rsl-hero');if(market&&hero)hero.after(market);}
rsPlaceMarketOptions();document.addEventListener('shopify:section:load',rsPlaceMarketOptions);

  } catch(e) { console.error(e); }
})();
})();
